import { supabase } from '../supabaseClient';

export const paymentsService = {

  async listByOrg(orgId) {
    const { data, error } = await supabase
      .from('payment_records')
      .select('*')
      .eq('org_id', orgId)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data || [];
  },

  async create(record) {
    const { data, error } = await supabase
      .from('payment_records')
      .insert([record])
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async update(id, changes) {
    const { data, error } = await supabase
      .from('payment_records')
      .update({ ...changes, updated_at: new Date().toISOString() })
      .eq('id', id)
      .select()
      .single();
    if (error) throw error;
    return data;
  },

  async delete(id) {
    const { error } = await supabase
      .from('payment_records')
      .delete()
      .eq('id', id);
    if (error) throw error;
  },

  async getNextInvoiceNo() {
    const { data, error } = await supabase.rpc('next_invoice_no');
    if (error) {
      // fallback: generate client-side
      const ts = Date.now().toString().slice(-5);
      return `INV-${ts}`;
    }
    return data;
  },

  async markOverdue() {
    await supabase.rpc('mark_overdue_payments');
  },

  async getOverdueCount() {
    const { count } = await supabase
      .from('payment_records')
      .select('id', { count: 'exact', head: true })
      .eq('status', 'overdue');
    return count || 0;
  },
};
